/**
 * Script for the Front Page
 *
 * @author Good Graphic Inc.
 * @version 2024-02-10
 */


/**
 * Dynamic Filter - Lists by Terms
 *
 * @author GoodGraphic
 * @version 2024-02-28
 */

(() => {
    class DynamicFilter {
        #maxCount;

        #bs;
        #its;
        #select = null;
       // #as;

        constructor(flt, list) {
            this.#maxCount = parseInt(list.dataset?.maxCount ?? "3");
            console.log()

            this.#bs = flt.querySelectorAll("button");
            this.#its = list.querySelectorAll(":scope > li");
            // this.#as = arch.querySelectorAll("a");
           // this.#createSelect(flt);

            this.#hideEmpty(list);
            for (const b of this.#bs) b.addEventListener("click", (e) => this.#onClick(e));
            this.#bs[0].click();
            this.#updateFilterUI(flt);

            window.addEventListener("resize", () => {
                this.#updateFilterUI(flt);
            });
        }

        #hideEmpty(list) {
            for (const b of this.#bs) {
                const t = b.dataset.type;
                if ("all" === t) continue;

                const it = list.querySelector(`:scope > li.${t}`);
                if (!it) {
                    b.classList.add("empty");
                    const p = b.parentElement;
                    if ("LI" === p.tagName) p.classList.add("empty");
                }
            }
        }

        #onClick(e) {
            const cur = e.currentTarget;
            for (const b of this.#bs) {
                const p = b.parentElement;
                if (cur === b) {
                    b.classList.add("current");
                    if ("LI" === p.tagName) p.classList.add("current");
                } else {
                    b.classList.remove("current");
                    if ("LI" === p.tagName) p.classList.remove("current");
                }
            }
            const t = cur.dataset.type;

            this.#filterItems(t, this.#maxCount);
           // const select = document.querySelector(".dynamic-filter-select");
            if (this.#select) {
                this.#select.value = t;
            }
        }

        #filterItems(t, count) {
            for (const it of this.#its) {
                if (count) {
                    const v = "all" === t || it.classList.contains(t);
                    if (v) {
                        it.style.display = "";
                        count -= 1;
                    } else {
                        it.style.display = "none";
                    }
                } else {
                    it.style.display = "none";
                }
            }
        }
        #updateFilterUI(flt) {
            const ul = flt.querySelector(".links");
            if (!ul) return;

            if (window.innerWidth <= 768) {
                if (!this.#select) {
                    const wrapper = document.createElement("div");
                    wrapper.className = "dynamic-filter-select-wrap";

                    this.#select = document.createElement("select");
                    this.#select.className = "dynamic-filter-select";

                    for (const b of this.#bs) {
                        const option = document.createElement("option");
                        option.value = b.dataset.type;
                        option.textContent = b.textContent.trim();
                        this.#select.appendChild(option);
                    }

                    this.#select.addEventListener("change", () => {
                        const button = [...this.#bs].find(
                            (b) => b.dataset.type === this.#select.value
                        );
                        button?.click();
                    });

                    wrapper.appendChild(this.#select);
                    flt.appendChild(wrapper);
                }

                const current = flt.querySelector("button.current");
                if (current) {
                    this.#select.value = current.dataset.type;
                }

                ul.hidden = true;
                this.#select.parentElement.hidden = false;
            } else {
                ul.hidden = false;

                if (this.#select) {
                    this.#select.parentElement.hidden = true;
                }
            }
        }
    }

    const fs = document.querySelectorAll(".part-dynamic-filter");
    if (1 === fs.length) {
        let l = document.querySelector(".part-dynamic-filter + .list-item");

        if (!l) {
            const id = fs[0].dataset?.filterId ?? "";
            if (id) {
                l = document.querySelector(`.list-item[data-filter-id='${id}']`);
            }
        }
        if (l) new DynamicFilter(fs[0], l);
    } else {
        for (const f of fs) {
            const id = f.dataset?.filterId ?? "";
            if (id) {
                const l = document.querySelector(`.list-item[data-filter-id='${id}']`);
                if (l) new DynamicFilter(f, l);
            }
        }
    }
})();

(function(factory) {
  typeof define === "function" && define.amd ? define(factory) : factory();
})(function() {

   class Slideshow {
    constructor(divId, options = {}) {
      this.items = [];
      this.hasImages = false;
      this.currentIndex = 0;
      this.isTransitioning = false;
      this.offset = 0;
      this.initialAnimationComplete = false;
      this.firstLoopComplete = false;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;
      this.dragOffset = 0;
      this.prevButton = null;
      this.nextButton = null;
      this.paginationContainer = null;
      this.paginationItems = [];
      this.resizeTimer = null;
      this.autoPlayInterval = null;
      this.dragListenersBound = false;
      this.hasDragged = false;
      this.options = this.normalizeOptions(options);
      this.defaultVisibleItems = this.options.visibleItems;
      this.defaultGap = this.options.gap;
      this.defaultAutoPlay = this.options.autoPlay;
      const container = document.getElementById(divId);
      if (!container) {
        throw new Error(`ID "${divId}" の要素が見つかりません`);
      }
      this.container = container;
      const ul = this.container.querySelector("ul");
      if (!ul) {
        throw new Error("ul要素が見つかりません");
      }
      this.ul = ul;
      this.originalItems = Array.from(this.ul.querySelectorAll(":scope > li"));
      if (this.originalItems.length === 0) {
        throw new Error("スライドに使用する<li>要素が見つかりません");
      }
      this.hasImages = this.checkForImages();
      this.paginationContainer = this.options.paginationTarget ? document.getElementById(this.options.paginationTarget) : this.container.querySelector(".pagination");
      this.boundHandleResize = this.handleResize.bind(this);
      this.boundHandleDragStartMouse = (event) => this.handleDragStart(event);
      this.boundHandleDragStartTouch = (event) => this.handleDragStart(event);
      this.boundHandleDragMoveMouse = (event) => this.handleDragMove(event);
      this.boundHandleDragMoveTouch = (event) => this.handleDragMove(event);
      this.boundHandleDragEndMouse = (event) => this.handleDragEnd(event);
      this.boundHandleDragEndTouch = (event) => this.handleDragEnd(event);
      this.boundPreventNativeDrag = (event) => event.preventDefault();
      this.boundHandleClickAfterDrag = (event) => this.handleClickAfterDrag(event);
      this.init();
      this.addResizeListener();
    }
    normalizeOptions(options) {
      const rawBreakpoints = options.breakpoints ?? {};
      const normalizedBreakpoints = {};
      Object.keys(rawBreakpoints).forEach((key) => {
        const numericKey = Number(key);
        if (!Number.isNaN(numericKey)) {
          normalizedBreakpoints[numericKey] = rawBreakpoints[key];
        }
      });
      const isDecimal = options.visibleItems !== void 0 && options.visibleItems % 1 !== 0;
      return {
        transitionTime: options.transitionTime ?? 600,
        displayTime: options.displayTime ?? 4e3,
        loadStyle: options.loadStyle ?? "full-width",
        loopMode: options.loopMode ?? false,
        visibleItems: options.visibleItems ?? 3,
        slideInFromRight: options.slideInFromRight ?? false,
        gap: options.gap ?? "0px",
        breakpoints: normalizedBreakpoints,
        draggable: options.draggable ?? true,
        // ドラッグ中にこの距離(px)を超えたら次/前へ送る
        dragThreshold: options.dragThreshold ?? 50,
        showControls: options.showControls ?? false,
        centerMode: options.centerMode ?? isDecimal,
        autoPlay: options.autoPlay ?? true,
        // 追加：デフォルトはtrue
        pageFlipFade: options.pageFlipFade ?? true,
        paginationTarget: options.paginationTarget ?? null
      };
    }
    checkForImages() {
      return this.originalItems.some((item) => {
        return item.querySelector("img") !== null;
      });
    }
    init() {
      this.applyBreakpoints();
      if (this.options.loopMode) {
        this.initLoopMode();
      } else {
        this.initNormalMode();
      }
      this.initControls();
      this.initPagination();
      setTimeout(() => {
        this.container.classList.remove("is-init");
      }, 200);
    }
    setInitialLoopPosition() {
      this.ul.style.transition = "none";
      if (this.options.slideInFromRight) {
        this.currentIndex = -1;
        this.offset = 100;
      } else {
        this.currentIndex = 0;
        const total = this.originalItems.length;
        if (this.options.centerMode) {
          this.currentIndex = total;
          this.offset = this.calculateCenterOffset(this.currentIndex);
        } else {
          this.currentIndex = 0;
          this.offset = 0;
        }
      }
      this.ul.style.transform = `translateX(${this.offset}%)`;
      this.ul.offsetHeight;
      this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
    }
    handleResizeImmediate() {
      if (this.isTransitioning || this.isDragging) {
        return;
      }
      const oldVisibleItems = this.options.visibleItems;
      const oldGap = this.options.gap;
      const oldAutoPlay = this.options.autoPlay;
      this.applyBreakpoints();
      if (oldAutoPlay !== this.options.autoPlay) {
        if (this.options.autoPlay) {
          this.startAutoPlay();
        } else {
          this.stopAutoPlay();
        }
      }
      if (oldVisibleItems !== this.options.visibleItems || oldGap !== this.options.gap) {
        this.reinitializeSlideshow();
      }
    }
    initControls() {
      if (!this.options.showControls) {
        return;
      }
      let controls = this.container.querySelector(".slideshow-controls");
      if (!controls) {
        controls = document.createElement("div");
        controls.className = "slideshow-controls";
        this.prevButton = document.createElement("button");
        this.prevButton.className = "prev";
        this.prevButton.innerHTML = "◀";
        this.nextButton = document.createElement("button");
        this.nextButton.className = "next";
        this.nextButton.innerHTML = "▶";
        controls.append(this.prevButton, this.nextButton);
        this.container.appendChild(controls);
      } else {
        this.prevButton = controls.querySelector(".prev") ?? null;
        this.nextButton = controls.querySelector(".next") ?? null;
        if (!this.prevButton) {
          this.prevButton = document.createElement("button");
          this.prevButton.className = "prev";
          this.prevButton.innerHTML = "◀";
          controls.appendChild(this.prevButton);
        }
        if (!this.nextButton) {
          this.nextButton = document.createElement("button");
          this.nextButton.className = "next";
          this.nextButton.innerHTML = "▶";
          controls.appendChild(this.nextButton);
        }
      }
      if (this.prevButton && this.prevButton.parentNode) {
        const newPrevButton = this.prevButton.cloneNode(true);
        this.prevButton.parentNode.replaceChild(newPrevButton, this.prevButton);
        this.prevButton = newPrevButton;
        this.prevButton.addEventListener("click", () => this.prev());
      }
      if (this.nextButton && this.nextButton.parentNode) {
        const newNextButton = this.nextButton.cloneNode(true);
        this.nextButton.parentNode.replaceChild(newNextButton, this.nextButton);
        this.nextButton = newNextButton;
        this.nextButton.addEventListener("click", () => this.next());
      }
    }
    initPagination() {
      if (!this.paginationContainer) {
        return;
      }
      this.paginationContainer.style.position = "relative";
      this.paginationContainer.style.zIndex = "100";
      this.paginationContainer.style.display = "";
      this.paginationContainer.innerHTML = "";
      this.paginationItems = [];
      const count = this.originalItems.length;
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement("span");
        dot.className = "pagination-dot";
        if (this.options.loopMode) {
          dot.addEventListener("click", () => this.goToLoop(i));
        } else {
          dot.addEventListener("click", () => this.goTo(i));
        }
        this.paginationContainer.appendChild(dot);
        this.paginationItems.push(dot);
      }
      this.updatePagination();
    }
    updatePagination() {
      if (!this.paginationItems.length) {
        return;
      }
      let activeIndex;
      if (this.options.loopMode) {
        activeIndex = this.currentIndex % this.originalItems.length;
        if (activeIndex < 0) {
          activeIndex = this.originalItems.length + activeIndex;
        }
      } else {
        activeIndex = this.currentIndex;
      }
      this.paginationItems.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }
    initNormalMode() {
      this.items = [...this.originalItems];
      if (this.options.loadStyle === "page-flip") {
        this.items.forEach((item) => {
          if (item.querySelector(".page")) return;
          const page = document.createElement("div");
          page.className = "page";
          while (item.firstChild) {
            page.appendChild(item.firstChild);
          }
          item.appendChild(page);
        });
      }
      this.setupNormalStyles();
      this.showInitial();
      this.updatePagination();
      if (this.options.autoPlay) {
        this.startAutoPlay();
      }
    }
    initLoopMode() {
      const cloneCount = Math.max(this.options.visibleItems * 3, this.originalItems.length * 3);
      this.ul.innerHTML = "";
      for (let i = 0; i < cloneCount; i++) {
        const clone = this.originalItems[i % this.originalItems.length].cloneNode(true);
        if (this.options.loadStyle === "page-flip") {
          const page = document.createElement("div");
          page.className = "page";
          while (clone.firstChild) {
            page.appendChild(clone.firstChild);
          }
          clone.appendChild(page);
        }
        this.ul.appendChild(clone);
      }
      this.items = Array.from(this.ul.querySelectorAll(":scope > li"));
      this.setupLoopStyles();
      this.setInitialLoopPosition();
      if (this.options.slideInFromRight) {
        this.animateInitialSlideIn();
      } else {
        this.firstLoopComplete = true;
        this.initialAnimationComplete = true;
        if (this.options.autoPlay) {
          this.startAutoPlay();
        }
      }
      if (this.options.draggable) {
        this.addDragListeners();
      }
    }
    setupNormalStyles() {
      this.container.style.position = "relative";
      this.container.style.overflow = "hidden";
      this.container.style.width = "100%";
      this.ul.style.position = "relative";
      this.ul.style.width = "100%";
      this.ul.style.height = "100%";
      this.ul.style.margin = "0";
      this.ul.style.padding = "0";
      this.ul.style.listStyle = "none";
      this.items.forEach((item, index) => {
        item.style.position = "absolute";
        item.style.top = "0";
        item.style.left = "0";
        item.style.width = "100%";
        item.style.height = this.hasImages ? "auto" : "100%";
        if (this.options.loadStyle === "slide-in") {
          item.style.transition = `all ${this.options.transitionTime}ms ease-in-out`;
          item.style.right = index === 0 ? "0" : "-100%";
        } else if (this.options.loadStyle === "fade" || this.options.loadStyle === "crossfade") {
          item.style.transition = `opacity ${this.options.transitionTime}ms ease-in-out`;
        } else if (this.options.loadStyle === "zoom-fade") {
          item.style.transition = `
                    opacity ${this.options.transitionTime}ms ease-in-out,
                    transform ${this.options.transitionTime}ms ease-in-out
                `;
          item.style.transform = "scale(1)";
        } else if (this.options.loadStyle === "page-flip") {
          item.style.opacity = "1";
          item.style.transition = `clip-path ${this.options.transitionTime}ms ease-in-out`;
          item.style.overflow = "hidden";
          item.style.backgroundColor = "transparent";
          if (index === 0) {
            item.style.zIndex = "10";
            item.style.clipPath = "inset(0 0 0 0)";
          } else if (index === 1) {
            item.style.zIndex = "5";
            item.style.clipPath = "inset(0 0 0 100%)";
          } else {
            item.style.zIndex = "1";
            item.style.clipPath = "inset(0 0 0 100%)";
          }
        } else {
          item.style.opacity = "0";
          item.style.transition = `all ${this.options.transitionTime}ms ease-in-out`;
        }
      });
    }
    setupLoopStyles() {
      this.container.style.position = "relative";
      this.container.style.overflow = "hidden";
      this.container.style.width = "100%";
      this.ul.style.display = "flex";
      this.ul.style.position = "relative";
      this.ul.style.height = this.hasImages ? "auto" : "100%";
      this.ul.style.margin = "0";
      this.ul.style.padding = "0";
      this.ul.style.listStyle = "none";
      this.ul.style.willChange = "transform";
      this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
      if (this.options.visibleItems === 1) {
        this.ul.style.gap = "0";
        this.ul.style.justifyContent = "flex-start";
        this.items.forEach((item) => {
          item.style.flex = "0 0 100%";
          item.style.width = "100%";
          item.style.height = this.hasImages ? "auto" : "100%";
          item.style.minWidth = "100%";
          item.style.boxSizing = "border-box";
        });
      } else {
        this.ul.style.gap = this.options.gap;
        this.ul.style.justifyContent = "flex-start";
        const gap = this.options.gap;
        const visibleItems = this.options.visibleItems;
        let itemWidth;
        if (gap.includes("%")) {
          const gapPercent = Number.parseFloat(gap) / 100;
          itemWidth = `calc((100% - ${(visibleItems - 1) * gapPercent * 100}%) / ${visibleItems})`;
        } else {
          itemWidth = `calc((100% - ${visibleItems - 1} * ${gap}) / ${visibleItems})`;
        }
        this.items.forEach((item) => {
          item.style.flex = `0 0 ${itemWidth}`;
          item.style.width = itemWidth;
          item.style.height = this.hasImages ? "auto" : "100%";
          item.style.minWidth = "0";
          item.style.boxSizing = "border-box";
        });
      }
    }
    calculateCenterOffset(index) {
      if (!this.options.centerMode) {
        const itemWidthPercentage = this.getSlideAmount();
        return -(index * itemWidthPercentage);
      }
      const containerWidth = this.container.offsetWidth;
      if (containerWidth === 0) {
        return 0;
      }
      const gap = this.options.gap;
      const visibleItems = this.options.visibleItems;
      let gapPx = 0;
      if (gap && gap !== "0" && gap !== "0px") {
        const gapValue = Number.parseFloat(gap);
        const gapUnit = gap.match(/[a-zA-Z%]+/)?.[0] ?? "px";
        if (gapUnit === "px") {
          gapPx = gapValue;
        } else if (gapUnit === "%") {
          gapPx = containerWidth * gapValue / 100;
        }
      }
      const totalGapWidth = (visibleItems - 1) * gapPx;
      const itemWidth = (containerWidth - totalGapWidth) / visibleItems;
      const itemWidthWithGap = itemWidth + gapPx;
      const currentItemLeft = index * itemWidthWithGap;
      const currentItemCenter = currentItemLeft + itemWidth / 2;
      const containerCenter = containerWidth / 2;
      const offsetPx = containerCenter - currentItemCenter;
      const offsetPercentage = offsetPx / containerWidth * 100;
      return offsetPercentage;
    }
    // ★修正：applyBreakpointsでautoPlayも更新
    applyBreakpoints() {
      const windowWidth = window.innerWidth;
      const breakpoints = this.options.breakpoints;
      this.options.visibleItems = this.defaultVisibleItems;
      this.options.gap = this.defaultGap;
      this.options.autoPlay = this.defaultAutoPlay;
      if (!breakpoints || Object.keys(breakpoints).length === 0) {
        return;
      }
      const sortedBreakpoints = Object.keys(breakpoints).map((key) => Number(key)).filter((value) => !Number.isNaN(value)).sort((a, b) => b - a);
      let applicableBreakpoint = null;
      for (const breakpoint of sortedBreakpoints) {
        if (windowWidth <= breakpoint) {
          applicableBreakpoint = breakpoint;
        }
      }
      if (applicableBreakpoint !== null) {
        const bpOptions = breakpoints[applicableBreakpoint];
        if (bpOptions) {
          if (bpOptions.visibleItems !== void 0) {
            this.options.visibleItems = bpOptions.visibleItems;
          }
          if (bpOptions.gap !== void 0) {
            this.options.gap = bpOptions.gap;
          }
          if (bpOptions.autoPlay !== void 0) {
            this.options.autoPlay = bpOptions.autoPlay;
          }
        }
      }
      if (this.options.visibleItems % 1 !== 0) {
        this.options.centerMode = true;
      }
    }
    handleResize() {
      if (this.isTransitioning || this.isDragging) {
        return;
      }
      if (this.resizeTimer) {
        window.clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = window.setTimeout(() => {
        const oldVisibleItems = this.options.visibleItems;
        const oldGap = this.options.gap;
        const oldAutoPlay = this.options.autoPlay;
        this.applyBreakpoints();
        if (oldAutoPlay !== this.options.autoPlay) {
          if (this.options.autoPlay) {
            this.startAutoPlay();
          } else {
            this.stopAutoPlay();
          }
        }
        if (oldVisibleItems !== this.options.visibleItems || oldGap !== this.options.gap) {
          this.reinitializeSlideshow();
        }
      }, 250);
    }
    reinitializeSlideshow() {
      this.stopAutoPlay();
      const currentCenterIndex = this.getCurrentCenterIndex();
      this.resetSlideshow();
      this.restorePreviousState(currentCenterIndex);
      window.setTimeout(() => {
        if (this.options.autoPlay) {
          this.startAutoPlay();
        }
      }, 100);
    }
    getCurrentCenterIndex() {
      if (!this.options.loopMode) {
        return this.currentIndex;
      }
      const totalOriginalItems = this.originalItems.length;
      const visibleItems = this.options.visibleItems;
      const centerIndex = Math.floor(visibleItems / 2);
      const currentIndex = this.currentIndex % totalOriginalItems;
      return (currentIndex + centerIndex) % totalOriginalItems;
    }
    resetSlideshow() {
      this.isTransitioning = false;
      this.isDragging = false;
      this.removeAllEventListeners();
      this.resetHTML();
      this.setupLoopStyles();
    }
    removeAllEventListeners() {
      if (this.options.draggable) {
        this.removeDragListeners();
      }
      if (this.prevButton && this.prevButton.parentNode) {
        const newPrevButton = this.prevButton.cloneNode(true);
        this.prevButton.parentNode.replaceChild(newPrevButton, this.prevButton);
        this.prevButton = newPrevButton;
      }
      if (this.nextButton && this.nextButton.parentNode) {
        const newNextButton = this.nextButton.cloneNode(true);
        this.nextButton.parentNode.replaceChild(newNextButton, this.nextButton);
        this.nextButton = newNextButton;
      }
    }
    resetHTML() {
      this.ul.innerHTML = "";
      const cloneCount = Math.max(this.options.visibleItems * 3, this.originalItems.length * 3);
      for (let i = 0; i < cloneCount; i += 1) {
        const clone = this.originalItems[i % this.originalItems.length].cloneNode(true);
        if (this.options.loadStyle === "page-flip") {
          const page = document.createElement("div");
          page.className = "page";
          while (clone.firstChild) {
            page.appendChild(clone.firstChild);
          }
          clone.appendChild(page);
        }
        this.ul.appendChild(clone);
      }
      this.items = Array.from(this.ul.querySelectorAll(":scope > li"));
    }
    restorePreviousState(centerIndex) {
      if (!this.options.loopMode) {
        return;
      }
      const itemWidthPercentage = this.getSlideAmount();
      const totalOriginalItems = this.originalItems.length;
      const visibleItems = this.options.visibleItems;
      let targetIndex;
      if (visibleItems === 1) {
        targetIndex = centerIndex;
        this.currentIndex = targetIndex;
        this.offset = this.options.centerMode ? this.calculateCenterOffset(targetIndex) : -(targetIndex * itemWidthPercentage);
      } else {
        const centerOffset = Math.floor(visibleItems / 2);
        targetIndex = (centerIndex - centerOffset + totalOriginalItems) % totalOriginalItems;
        this.currentIndex = targetIndex + totalOriginalItems;
        this.offset = this.options.centerMode ? this.calculateCenterOffset(this.currentIndex) : -(this.currentIndex * itemWidthPercentage);
      }
      this.ul.style.transition = "none";
      this.ul.style.transform = `translateX(${this.offset}%)`;
      window.setTimeout(() => {
        this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
        if (this.options.draggable) {
          this.addDragListeners();
        }
        this.initControls();
      }, 50);
    }
    addResizeListener() {
      window.addEventListener("resize", this.boundHandleResize);
    }
    removeResizeListener() {
      window.removeEventListener("resize", this.boundHandleResize);
    }
    getSlideAmount() {
      const visibleItems = this.options.visibleItems;
      const gap = this.options.gap;
      if (visibleItems === 1) {
        return 100;
      }
      if (gap === "0px" || gap === "0") {
        return 100 / visibleItems;
      }
      const containerWidth = this.container.offsetWidth;
      if (containerWidth === 0) {
        return 100 / visibleItems;
      }
      const gapValue = Number.parseFloat(gap);
      const gapUnit = gap.match(/[a-zA-Z%]+/)?.[0] ?? "px";
      if (gapUnit === "px") {
        const itemWidthPx = (containerWidth - (visibleItems - 1) * gapValue) / visibleItems;
        const slideAmountPx = itemWidthPx + gapValue;
        return slideAmountPx / containerWidth * 100;
      }
      return 100 / visibleItems;
    }
    getEventX(event) {
      if ("touches" in event) {
        return event.touches[0]?.clientX ?? 0;
      }
      return event.clientX;
    }
    addDragListeners() {
      if (this.dragListenersBound) {
        return;
      }
      this.ul.addEventListener("mousedown", this.boundHandleDragStartMouse);
      this.ul.addEventListener("touchstart", this.boundHandleDragStartTouch);
      document.addEventListener("mousemove", this.boundHandleDragMoveMouse);
      document.addEventListener("touchmove", this.boundHandleDragMoveTouch);
      document.addEventListener("mouseup", this.boundHandleDragEndMouse);
      document.addEventListener("touchend", this.boundHandleDragEndTouch);
      this.ul.addEventListener("dragstart", this.boundPreventNativeDrag);
      this.ul.addEventListener("click", this.boundHandleClickAfterDrag, true);
      this.ul.style.cursor = "grab";
      this.ul.style.userSelect = "none";
      this.dragListenersBound = true;
    }
    removeDragListeners() {
      if (!this.dragListenersBound) {
        return;
      }
      this.ul.removeEventListener("mousedown", this.boundHandleDragStartMouse);
      this.ul.removeEventListener("touchstart", this.boundHandleDragStartTouch);
      document.removeEventListener("mousemove", this.boundHandleDragMoveMouse);
      document.removeEventListener("touchmove", this.boundHandleDragMoveTouch);
      document.removeEventListener("mouseup", this.boundHandleDragEndMouse);
      document.removeEventListener("touchend", this.boundHandleDragEndTouch);
      this.ul.removeEventListener("dragstart", this.boundPreventNativeDrag);
      this.ul.removeEventListener("click", this.boundHandleClickAfterDrag, true);
      this.dragListenersBound = false;
    }
    handleDragStart(event) {
      if (!this.options.draggable || this.isTransitioning || !this.options.loopMode) {
        return;
      }
      if (!("touches" in event)) {
        if (event.button !== 0) {
          return;
        }
        // テキスト選択・画像のネイティブドラッグを防ぐ
        event.preventDefault();
      }
      this.isDragging = true;
      this.hasDragged = false;
      this.startX = this.getEventX(event);
      this.dragOffset = 0;
      this.stopAutoPlay();
      this.ul.style.transition = "none";
      this.ul.style.cursor = "grabbing";
    }
    handleDragMove(event) {
      if (!this.isDragging) {
        return;
      }
      this.currentX = this.getEventX(event);
      const dragDistancePx = this.currentX - this.startX;
      if (Math.abs(dragDistancePx) > 5) {
        this.hasDragged = true;
      }
      // 一定距離ドラッグした時点で離すのを待たずにスライドを送る
      if (Math.abs(dragDistancePx) >= this.options.dragThreshold) {
        this.finishDrag();
        if (dragDistancePx < 0) {
          this.nextLoop();
        } else {
          this.prevLoop();
        }
        return;
      }
      const containerWidth = this.container.offsetWidth || 1;
      const dragDistancePercentage = dragDistancePx / containerWidth * 100;
      this.ul.style.transform = `translateX(${this.offset + dragDistancePercentage}%)`;
      this.dragOffset = dragDistancePercentage;
    }
    handleDragEnd(_) {
      if (!this.isDragging) {
        return;
      }
      // 閾値に届かなかった場合は元の位置へ戻す
      this.finishDrag();
      this.ul.style.transform = `translateX(${this.offset}%)`;
    }
    finishDrag() {
      this.isDragging = false;
      this.dragOffset = 0;
      this.ul.style.cursor = "grab";
      this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
      if (this.options.autoPlay) {
        this.startAutoPlay();
      }
    }
    handleClickAfterDrag(event) {
      // ドラッグ直後のクリックでリンク遷移させない
      if (!this.hasDragged) {
        return;
      }
      this.hasDragged = false;
      event.preventDefault();
      event.stopPropagation();
    }
    animateInitialSlideIn() {
      const totalSlides = this.originalItems.length;
      let appearCount = 0;
      const slideInNext = () => {
        if (appearCount < totalSlides) {
          window.setTimeout(() => {
            const itemWidthPercentage = this.options.visibleItems === 1 ? 100 : this.getSlideAmount();
            this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
            if (this.options.centerMode) {
              this.currentIndex += 1;
              this.offset = this.calculateCenterOffset(this.currentIndex);
            } else {
              this.offset -= itemWidthPercentage;
              this.currentIndex += 1;
            }
            this.ul.style.transform = `translateX(${this.offset}%)`;
            appearCount += 1;
            slideInNext();
          }, this.options.transitionTime + this.options.displayTime);
        } else {
          window.setTimeout(() => {
            this.initialAnimationComplete = true;
            this.firstLoopComplete = true;
            if (this.options.autoPlay) {
              this.startAutoPlay();
            }
          }, this.options.displayTime);
        }
      };
      window.setTimeout(() => {
        slideInNext();
      }, 300);
    }
    showInitial() {
      const firstItem = this.items[0];
      if (!firstItem) {
        return;
      }
      if (this.options.loadStyle === "slide-in") {
        window.setTimeout(() => {
          firstItem.style.right = "0";
          firstItem.style.opacity = "1";
        }, 100);
      } else if (this.options.loadStyle === "page-flip") {
        firstItem.style.clipPath = "inset(0 0 0 0)";
        firstItem.style.zIndex = "2";
        return;
      } else {
        firstItem.style.opacity = "1";
      }
    }
    transition(fromIndex, toIndex) {
      if (this.options.loopMode || this.isTransitioning) {
        return;
      }
      this.isTransitioning = true;
      const currentItem = this.items[fromIndex];
      const nextItem = this.items[toIndex];
      if (!currentItem || !nextItem) {
        this.isTransitioning = false;
        return;
      }
      const wasAutoPlaying = this.autoPlayInterval !== null;
      this.stopAutoPlay();
      const completeTransition = () => {
        this.isTransitioning = false;
        this.updatePagination();
        if (wasAutoPlaying && this.options.autoPlay) {
          this.startAutoPlay();
        }
      };
      if (this.options.loadStyle === "slide-in") {
        nextItem.style.right = "-100%";
        nextItem.style.opacity = "1";
        window.setTimeout(() => {
          currentItem.style.right = "100%";
          nextItem.style.right = "0";
        }, 50);
        window.setTimeout(() => {
          currentItem.style.right = "-100%";
          completeTransition();
        }, this.options.transitionTime);
      } else if (this.options.loadStyle === "fade") {
        currentItem.style.opacity = "0";
        window.setTimeout(() => {
          currentItem.style.zIndex = "1";
          nextItem.style.zIndex = "2";
          nextItem.style.opacity = "1";
          window.setTimeout(completeTransition, this.options.transitionTime);
        }, this.options.transitionTime);
      } else if (this.options.loadStyle === "crossfade") {
        currentItem.style.zIndex = "1";
        nextItem.style.zIndex = "2";
        nextItem.style.opacity = "0";
        window.setTimeout(() => {
          currentItem.style.opacity = "0";
          nextItem.style.opacity = "1";
          window.setTimeout(completeTransition, this.options.transitionTime);
        }, 50);
      } else if (this.options.loadStyle === "zoom-fade") {
        nextItem.style.zIndex = "1";
        nextItem.style.opacity = "0";
        nextItem.style.transform = "scale(1)";
        currentItem.style.zIndex = "2";
        window.setTimeout(() => {
          currentItem.style.opacity = "0";
          currentItem.style.transform = "scale(1.2)";
          window.setTimeout(() => {
            nextItem.style.zIndex = "2";
            nextItem.style.opacity = "1";
            window.setTimeout(() => {
              currentItem.style.transform = "scale(1)";
              currentItem.style.zIndex = "1";
              completeTransition();
            }, this.options.transitionTime);
          }, 50);
        }, 50);
      } else if (this.options.loadStyle === "page-flip") {
        const fromRight = this.options.slideInFromRight;
        const closed = fromRight ? "inset(0 0 0 100%)" : "inset(0 100% 0 0)";
        const open = "inset(0 0 0 0)";
        this.items.forEach((item, index) => {
          item.style.transition = "none";
          if (index === toIndex) {
            item.style.zIndex = "10";
            item.style.clipPath = closed;
          } else if (index === fromIndex) {
            item.style.zIndex = "5";
            item.style.clipPath = open;
          } else {
            item.style.zIndex = "2";
            item.style.clipPath = closed;
          }
          item.style.opacity = "1";
        });
        this.items.forEach((item) => item.getBoundingClientRect());
        requestAnimationFrame(() => {
          nextItem.style.transition = `clip-path ${this.options.transitionTime}ms ease-in-out`;
          nextItem.style.clipPath = open;
          window.setTimeout(() => {
            this.items.forEach((item, index) => {
              item.style.transition = "none";
              if (index === toIndex) {
                item.style.clipPath = open;
              } else {
                item.style.clipPath = closed;
              }
            });
            this.items.forEach((item) => item.getBoundingClientRect());
            requestAnimationFrame(() => {
              this.items.forEach((item) => {
                item.style.transition = `clip-path ${this.options.transitionTime}ms ease-in-out`;
              });
              completeTransition();
            });
          }, this.options.transitionTime);
        });
      } else {
        nextItem.style.opacity = "1";
        currentItem.style.opacity = "0";
        window.setTimeout(completeTransition, this.options.transitionTime);
      }
    }
    next() {
      if (this.options.loopMode) {
        this.nextLoop();
      } else {
        this.nextNormal();
      }
    }
    prev() {
      if (this.options.loopMode) {
        this.prevLoop();
      } else {
        this.prevNormal();
      }
    }
    nextNormal() {
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      this.transition(this.currentIndex, nextIndex);
      this.currentIndex = nextIndex;
    }
    prevNormal() {
      const prevIndex = this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
      this.transition(this.currentIndex, prevIndex);
      this.currentIndex = prevIndex;
    }
    nextLoop() {
      if (this.isTransitioning) {
        return;
      }
      this.isTransitioning = true;
      const itemWidthPercentage = this.getSlideAmount();
      this.currentIndex += 1;
      if (this.options.centerMode) {
        this.offset = this.calculateCenterOffset(this.currentIndex);
      } else {
        this.offset -= itemWidthPercentage;
      }
      this.ul.style.transform = `translateX(${this.offset}%)`;
      window.setTimeout(() => {
        const resetPoint = this.originalItems.length * 2;
        if (this.currentIndex >= resetPoint) {
          this.ul.style.transition = "none";
          this.currentIndex -= this.originalItems.length;
          if (this.options.centerMode) {
            this.offset = this.calculateCenterOffset(this.currentIndex);
          } else {
            this.offset = -(this.currentIndex * itemWidthPercentage);
          }
          this.ul.style.transform = `translateX(${this.offset}%)`;
          window.setTimeout(() => {
            this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
            this.isTransitioning = false;
            this.updatePagination();
          }, 50);
        } else {
          this.isTransitioning = false;
          this.updatePagination();
        }
      }, this.options.transitionTime);
    }
    prevLoop() {
      if (this.isTransitioning) {
        return;
      }
      this.isTransitioning = true;
      const itemWidthPercentage = this.getSlideAmount();
      if (this.currentIndex <= 0) {
        this.ul.style.transition = "none";
        this.currentIndex = this.originalItems.length;
        if (this.options.centerMode) {
          this.offset = this.calculateCenterOffset(this.currentIndex);
        } else {
          this.offset = -(this.currentIndex * itemWidthPercentage);
        }
        this.ul.style.transform = `translateX(${this.offset}%)`;
        window.setTimeout(() => {
          this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
          this.currentIndex -= 1;
          if (this.options.centerMode) {
            this.offset = this.calculateCenterOffset(this.currentIndex);
          } else {
            this.offset += itemWidthPercentage;
          }
          this.ul.style.transform = `translateX(${this.offset}%)`;
          window.setTimeout(() => {
            this.isTransitioning = false;
            this.updatePagination();
          }, this.options.transitionTime);
        }, 50);
      } else {
        this.currentIndex -= 1;
        if (this.options.centerMode) {
          this.offset = this.calculateCenterOffset(this.currentIndex);
        } else {
          this.offset += itemWidthPercentage;
        }
        this.ul.style.transform = `translateX(${this.offset}%)`;
        window.setTimeout(() => {
          this.isTransitioning = false;
          this.updatePagination();
        }, this.options.transitionTime);
      }
    }
    goTo(index) {
      if (this.options.loopMode) {
        return;
      }
      if (index < 0 || index >= this.items.length || index === this.currentIndex) {
        return;
      }
      this.transition(this.currentIndex, index);
      this.currentIndex = index;
      this.updatePagination();
    }
    goToLoop(targetIndex) {
      if (!this.options.loopMode || this.isTransitioning) {
        return;
      }
      const totalOriginalItems = this.originalItems.length;
      let currentActiveIndex = this.currentIndex % totalOriginalItems;
      if (currentActiveIndex < 0) {
        currentActiveIndex = totalOriginalItems + currentActiveIndex;
      }
      if (targetIndex < 0 || targetIndex >= totalOriginalItems) {
        return;
      }
      if (currentActiveIndex === targetIndex) {
        return;
      }
      this.isTransitioning = true;
      const itemWidthPercentage = this.getSlideAmount();
      const distance = targetIndex - currentActiveIndex;
      const forwardDistance = distance >= 0 ? distance : distance + totalOriginalItems;
      const backwardDistance = distance <= 0 ? -distance : totalOriginalItems - distance;
      const moveForward = forwardDistance <= backwardDistance;
      const steps = moveForward ? forwardDistance : backwardDistance;
      const newIndex = this.currentIndex + (moveForward ? steps : -steps);
      let newOffset;
      if (this.options.centerMode) {
        newOffset = this.calculateCenterOffset(newIndex);
      } else {
        newOffset = moveForward ? this.offset - steps * itemWidthPercentage : this.offset + steps * itemWidthPercentage;
      }
      this.currentIndex = newIndex;
      this.offset = newOffset;
      this.ul.style.transform = `translateX(${this.offset}%)`;
      window.setTimeout(() => {
        const resetPoint = totalOriginalItems * 2;
        if (this.currentIndex >= resetPoint || this.currentIndex < 0) {
          this.ul.style.transition = "none";
          this.currentIndex = (this.currentIndex % totalOriginalItems + totalOriginalItems) % totalOriginalItems;
          this.currentIndex += totalOriginalItems;
          if (this.options.centerMode) {
            this.offset = this.calculateCenterOffset(this.currentIndex);
          } else {
            this.offset = -(this.currentIndex * itemWidthPercentage);
          }
          this.ul.style.transform = `translateX(${this.offset}%)`;
          window.setTimeout(() => {
            this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
            this.isTransitioning = false;
            this.updatePagination();
          }, 50);
        } else {
          this.isTransitioning = false;
          this.updatePagination();
        }
      }, this.options.transitionTime);
    }
    startAutoPlay() {
      this.stopAutoPlay();
      if (!this.options.autoPlay) {
        return;
      }
      this.autoPlayInterval = window.setInterval(() => {
        this.next();
      }, this.options.displayTime);
    }
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        window.clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    }
    destroy() {
      this.stopAutoPlay();
      if (this.resizeTimer) {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }
      if (this.options.draggable) {
        this.removeDragListeners();
      }
      this.removeResizeListener();
    }
    reset() {
      this.stopAutoPlay();
      if (this.options.loopMode && this.options.slideInFromRight) {
        this.firstLoopComplete = false;
        this.initialAnimationComplete = false;
        this.currentIndex = -1;
        this.offset = 100;
        this.ul.style.transition = "none";
        this.ul.style.transform = `translateX(${this.offset}%)`;
        window.setTimeout(() => {
          this.animateInitialSlideIn();
        }, 100);
        return;
      }
      if (this.options.loopMode) {
        this.currentIndex = 0;
        this.offset = this.options.centerMode ? this.calculateCenterOffset(0) : 0;
        this.ul.style.transition = "none";
        this.ul.style.transform = `translateX(${this.offset}%)`;
        window.setTimeout(() => {
          this.ul.style.transition = `transform ${this.options.transitionTime}ms ease-in-out`;
          if (this.options.autoPlay) {
            this.startAutoPlay();
          }
        }, 50);
        return;
      }
      this.items.forEach((item, index) => {
        item.style.opacity = "0";
        if (this.options.loadStyle === "slide-in") {
          item.style.right = index === 0 ? "0" : "-100%";
        }
        if (this.options.loadStyle === "zoom-fade") {
          item.style.transform = "scale(1)";
        }
      });
      this.currentIndex = 0;
      this.showInitial();
      this.updatePagination();
      if (this.options.autoPlay) {
        this.startAutoPlay();
      }
    }
  }
  const setupSlideshowControls = (slideshows2) => {
    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      const button = target.closest("button[data-action]");
      if (!button) {
        return;
      }
      const action = button.dataset.action;
      const slideshowName = button.dataset.slideshow;
      if (!action || !slideshowName) {
        return;
      }
      const slideshow = slideshows2[slideshowName];
      if (!slideshow) {
        return;
      }
      switch (action) {
        case "prev":
          slideshow.prev();
          break;
        case "next":
          slideshow.next();
          break;
        case "stop":
          slideshow.stopAutoPlay();
          break;
        case "start":
          slideshow.startAutoPlay();
          break;
        case "reset":
          slideshow.reset();
          break;
        default:
          console.warn(`Unknown action: ${action}`);
          break;
      }
    });
  };


  const slideshows = {};
  // gg-slideshow-ja
  if (document.getElementById('gg-slideshow')) {
    slideshows.ggJa = new Slideshow('gg-slideshow', {
      transitionTime: 600,
      displayTime: 2500,
      loopMode: true,
      visibleItems: 5,
      slideInFromRight: false,
      gap: "28px",
      paginationTarget: "pagination",
      breakpoints: {
        600: {
          visibleItems: 1.2,
          autoPlay: false,
          gap: "15px"
        },
        900: {
            visibleItems: 2.25,
            gap: "15px",
          },
        1500: {
            visibleItems: 3.25,
            gap: "15px",
          }
      }
    });
  }



  setupSlideshowControls(slideshows);
}); // 括弧とじ漏れ修正
